<template>
  <div>
    <digitalFranchisePurchaseSidebar />
    <div style="position: relative" >
      <app-breadcrumb :breadcrumbTitle="false">
        <b-button
          variant="primary"
          @click="editDigitalFranchisePurchase(undefined)"
          style="position: absolute; right: 13"
        >
          <feather-icon icon="PlusCircleIcon" class="mr-50" />
          <span class="text-nowrap">Nova Compra</span>
        </b-button>
      </app-breadcrumb>
    </div>
    <!-- Table Container Card -->
    <!-- Filtros -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5 class="mb-1">Filtros</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="4" class="mb-1">
            <b-form-group 
              label="Nome do interessado" 
              label-for="digital-franchise-type"
              class="mt-1"
            >
              <b-form-input
                v-model="consultant"
                class="d-inline-block mr-1"
                @keyup.enter="search"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group 
              label="Tipo de franquia" 
              label-for="digital-franchise-type"
              class="mt-1"
            >
              <v-select
                id="digital-franchise-type"
                multiple
                v-model="franchise"
                :reduce="(franchises) => franchises.key"
                :options="franchiseOptions"
                :loadingFilters="loading.franchiseTypes"
                :disabled="loadingFilters.franchiseTypes"
                label="name"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group 
              label="Status da compra" 
              label-for="digital-franchise-status"
              class="mt-1"
            >
              <v-select
                id="digital-franchise-status"
                multiple
                v-model="status"
                :reduce="(statuses) => statuses.key"
                :options="statusOptions"
                :loadingFilters="loading.statusOptions"
                :disabled="loadingFilters.statusOptions"
                label="name"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mb-md-0 mb-2 text-right">
            <b-button
              variant="outline-primary"
              @click.prevent="search"
              :disabled="loading"
            >
              <b-spinner v-if="loading" small />
              <feather-icon v-else icon="SearchIcon" class="mr-50" />
              <span>
                {{ loading ? "Aguarde..." : "Pesquisar" }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mb-0">Exibir</label>
            <v-select
              v-model="itemsPerPage"
              dir="ltr"
              :options="itemsPerPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="search(currentPage)"
            >
              <template #no-options="{ search, searching, loading }">
                Sem resultados
              </template>
            </v-select>
            <label class="mb-0">itens</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </b-col>
        </b-row>
      </div>
      <b-table
        hover
        class="position-relative text-center lead-table"
        :items="items"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="Não foram encontrados leads para esta busca"
        :busy="loading"
        :primary-key="'customer_id'"
      >
        <template #cell(consultant_network)="data">
          <div class="text-wrap">
            <div v-for="(network, index) in data.item.consultant_network" :key="index">
              <span  class="align-text-top text-capitalize">{{
                network.name + ' - ' + network.role_name
              }}</span>
              <br>
            </div>
          </div>
        </template>

        <template #cell(amount)="data">
          <div class="text-wrap">
            <span  class="align-text-top text-capitalize">{{
              data.item.amount | toCurrency
            }}</span>
          </div>
        </template>

        <template #cell(approved_at)="data">
          <div class="text-wrap">
            <span v-if="data.item.approved_at" class="align-text-top">{{
              data.item.approved_at | onlyDate
            }}</span>
            <span v-else class="align-text-top">Aguardando aprovação</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-wrap">
            <b-button-group>
              <b-button
                v-if="data.item.status == 'pending'"
                :id="`digital-purchase-` + data.item.id"
                class="btn-icon mr-1"
                variant="flat"
                style="padding: 0"
                @click="editDigitalFranchisePurchase(data.item.id)"
              >
                <feather-icon class="text-body" icon="CheckSquareIcon" />
              </b-button>
            </b-button-group>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Exibindo {{ pageItemsFrom }} à {{ pageItemsTo }} de
              {{ totalItems }} itens</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="itemsPerPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="search"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  BSpinner,
  BCardText,
  BMediaAside,
  BMediaBody,
  BCardTitle,
  BButtonGroup,
  BTooltip,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";
import useAppConfig from "@core/app-config/useAppConfig";
import AppBreadcrumb from "@core/layouts/components/AppBreadcrumb.vue";
import { statusOptions } from "@/constants/financial_adjustments";
import DigitalFranchisePurchaseSidebar from "../components/DigitalFranchisePurchaseSidebar.vue";
import { toCurrency } from "@/helpers/converters";


export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BCardText,
    BCardTitle,
    BMediaAside,
    BMediaBody,
    BButtonGroup,
    BTooltip,
    vSelect,
    AppBreadcrumb,
    BFormCheckbox,
    DigitalFranchisePurchaseSidebar
  },
  setup() {
    const { skin } = useAppConfig();

    return { toast: useToast(), skin };
  },
  data() {
    return {
      loading: false,
      loadingFilters: {
        franchiseTypes: false,
        statusOptions: false,
      },
      currentPage: 1,
      itemsPerPage: 1,
      consultant: undefined,
      status: undefined,
      franchise: undefined,
      sortField: null,
      order: undefined,
      tableColumns:[
        { key: "consultant_name", label: "PN interessado", sortable: true },
        { key: "leader_name", label: "PN líder", sortable: true },
        { key: "consultant_network", label: "Estrutura" },
        { key: "status_label", label: "Status" },
        { key: "franchise_type_label", label: "Tipo de franquia" },
        { key: "added_by_name", label: "Cadastrado por", sortable: true },
        { key: "amount", label: "Valor da franquia", sortable: true },
        { key: "payment_format", label: "Forma de pagamento", sortable: true },
        { key: "approved_by_name", label: "Aprovado por", sortable: true },
        { key: "approved_at", label: "Data de aprovação", sortable: true },
        { key: "actions", label: "Ações", sortable: false },
      ]
    };
  },
  computed: {
    ...mapGetters({
      searchResult: types.DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT,
      franchiseOptions: types.DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES,
      statusOptions: types.DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS,
      initialItemsPerPage: sharedTypes.INITIAL_ITEMS_PER_PAGE,
      itemsPerPageOptions: sharedTypes.ITEMS_PER_PAGE_OPTIONS,
    }),
    items: function () {
      return this.searchResult?.data || [];
    },
    totalItems: function () {
      return this.searchResult?.total || 0;
    },
    pageItemsFrom: function () {
      return this.searchResult?.from || 0;
    },
    pageItemsTo: function () {
      return this.searchResult?.to || 0;
    },
  },
  async mounted() {
    this.itemsPerPage = this.initialItemsPerPage;
    await this.search();
    this.loadingFilters.franchiseTypes = true;
    this.getFranchiseTypes()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os tipos de franquia para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilters.franchiseTypes = false;
      });
    this.loadingFilters.statusOptions = true;
    this.getStatusOptions()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os tipos de franquia para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilters.statusOptions = false;
      });
    if(this.$route.query.edit){
      this.editDigitalFranchisePurchase(this.$route.query.edit);
    }
  },
  methods: {
    ...mapActions({
      searchPurchases: types.SEARCH_DIGITAL_FRANCHISES_PURCHASE,
      openNewFranchiseSidebar: types.OPEN_NEW_FRANCHISE_SIDEBAR,
      getFranchiseTypes: types.GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES,
      getStatusOptions: types.GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS,
      openDigitalFranchisePurchaseSidebar: types.OPEN_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR,
    }),

    search(currentPage) {
      this.loading = true;
      this.currentPage = Number.isInteger(currentPage) ? currentPage : 1;

      this.searchPurchases({
        consultant_name: this.consultant,
        status: this.status,
        franchise_type: this.franchise,
        currentPage: this.currentPage,
        limit: this.itemsPerPage,
      })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao buscar as franquias. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editDigitalFranchisePurchase(id) {
      this.openDigitalFranchisePurchaseSidebar({ 
        id,
        consultant_id: undefined,
        saveAction: () => {
          this.search(this.currentPage)
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.img_action {
  width: 16px;
  height: 16px;
}

#buttons {
  border: 0px;
}

input[type="datetime-local"] {
  width: 180px;
}

.lead-table .phone {
  color: #e3e3e3;
}

.dark-layout .lead-table .phone {
  color: #676d7d;
}

.lead-table .name-content {
  width: 170px;
  display: flex;
  justify-content: center;
}

.lead-table .name-content .name {
  width: auto;
}

.lead-table .name-content .name:hover {
  background-color: #f26237;
}

.lead-table .name-content .whats {
  width: 27px;
  margin-left: 8px;
  margin-top: auto;
  margin-bottom: auto;
}

.lead-table .name-content .whats:hover {
  background-color: #f26237;
}

.lead-table .btn-group .btn {
  border: unset !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

table #buttons {
  width: 40px;
}

.b-table-sticky-column:last-child {
  right: 0;
}

.lead-table thead th {
  white-space: nowrap !important;
}
</style>
